<template>
  <div class="product-grid">
    <ul>
      <li v-for="item in list" :key="item.id">
        <router-link :to="{ path: '/goods/details', query: {productID:item.id} }">
          <img :src="item.img_path" alt />
          <h2>{{ item.name }}</h2>
          <h3>{{ item.title }}</h3>
          <p>
            <span>{{ item.discount_price }} ₹</span>
            <span v-show="item.price != item.discount_price" class="del">{{ item.price }}₹</span>
          </p>
        </router-link>
      </li>
      <li v-if="isMore && list && list.length" class="more-tile">
        <router-link :to="{ path: '/goods', query: {categoryID:categoryIDs} }">
          More
          <i class="el-icon-d-arrow-right"></i>
        </router-link>
      </li>
    </ul>
  </div>
  </template>
  <script>
  export default {
    name: 'ProductGrid',
    props: {
      list: {
        type: Array,
        default: () => []
      },
      isMore: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      categoryIDs() {
        const ids = []
        if (this.list && this.list.length) {
          for (let i = 0; i < this.list.length; i++) {
            const id = this.list[i].category_id
            if (!ids.includes(id)) ids.push(id)
          }
        }
        return ids
      }
    }
  }
  </script>
  <style scoped>
  .product-grid ul {
    margin: 0;
    padding: 0;
    list-style: none;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
  }
  .product-grid ul li {
    width: 100%;
    min-width: 0;
    min-height: 490px;
    padding: 14px;
    overflow: hidden;
    background-color: #ffffff;
    border-radius: 10px;
    border: 1px solid #efeaf3;
    transition: all 0.2s linear;
  }
  .product-grid ul li a {
    display: block;
    color: inherit;
  }
  .product-grid ul li:hover {
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
    transform: translate3d(0, -2px, 0);
  }
  .product-grid ul li img {
    display: block;
    width: 100%;
    height: 410px;
    background: url(../assets/imgs/placeholder.png) no-repeat 50%;
    border-radius: 8px;
    object-fit: cover;
  }
  .product-grid ul li h2 {
    margin: 12px 0 0;
    font-size: 14px;
    font-weight: 600;
    color: #2f2238;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-align: left;
  }
  .product-grid ul li h3 {
    margin: 6px 0 0;
    height: 18px;
    font-size: 11px;
    font-weight: 400;
    color: #8a7f97;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .product-grid ul li p {
    margin: 10px 0 0;
    display: flex;
    justify-content: flex-start;
    gap: 8px;
    color: #ff5f8f;
    font-weight: 600;
  }
  .product-grid ul li p .del {
    color: #b9afc5;
    text-decoration: line-through;
  }
  .more-tile {
    display: flex;
    min-height: 490px;
    align-items: center;
    justify-content: center;
    border: 1px dashed #d7cfdf;
  }
  .more-tile a {
    font-size: 14px;
    color: #5a4b6c;
    text-transform: uppercase;
    letter-spacing: 0.6px;
  }
  .more-tile a:hover {
    color: #ff5f8f;
  }
  @media (max-width: 900px) {
    .product-grid ul {
      grid-template-columns: repeat(2, 1fr);
    }
    .product-grid ul li,
    .more-tile {
      min-height: 410px;
    }
    .product-grid ul li img {
      height: 280px;
    }
  }
  </style>
